//@ts-nocheck
import CryptoJS from "crypto-js";
import { getConfig } from ".././config/config";
import { convertTimestamp, hexToAscii } from '../helpers';
const { APP_BASE_PORTFOLIO_API_URL } = getConfig();
const getAuthToken = async () => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("APIKey", "jvkH7wK5Yp9GzsnvRoHDAQ==");
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            ApplicationType: "WhatsApp"
        });
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };
        const response = await fetch(`${APP_BASE_PORTFOLIO_API_URL}ContainerAPI/Services.GenerateAuthToken`, requestOptions);
        const result = await response.json();
        return result;
    }
    catch (error) {
        console.error("Error generating auth token:", error);
    }
};
const getDashboardToken = async () => {
    try {
        const authData = {
            authToken: "",
            sessionId: "",
        };
        const response = await getAuthToken();
        if ((response === null || response === void 0 ? void 0 : response.Message) === "Success") {
            const KeyIV = hexToAscii(response.Token);
            localStorage.setItem("DASHBOARD_AUTH_TOKEN", response.Token);
            const sessionId = await getDionSessionNo(KeyIV.split(",")[0], KeyIV.split(",")[1], response.Token);
            authData.authToken = response.Token;
            authData.sessionId = sessionId;
            return authData;
        }
        else {
            console.log("Token not generated");
        }
    }
    catch (err) {
        console.error("Error occurred while fetching dashboard token:", err);
    }
};
const getDashboardData = async (token, inputStr) => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        let timeNow = `${localStorage.getItem("ClientCode")}-${convertTimestamp(Date.now())}`;
        myHeaders.append("RequestRefNo", timeNow);
        myHeaders.append("Content-Type", "application/json");
        const raw = inputStr;
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        const response = await fetch(`${APP_BASE_PORTFOLIO_API_URL}PortfolioTrackerAPI/PTService.ProcessRequest`, requestOptions);
        const result = response.json();
        return result;
    }
    catch (error) {
        console.error("Error fetching dashboard data:", error.message || error);
        throw error;
    }
};
const getDionSessionNo = async (key, iv, token) => {
    try {
        const loginDion = {
            LoginId: localStorage.getItem("ClientCode"),
            Password: "",
        };
        const EncryptedData = EncryptSessionId(JSON.stringify(loginDion), key, iv);
        const InputStr = '{ "data": "Login^Login^' + EncryptedData + '"}';
        const response = await getDashboardData(token, InputStr);
        if ((response === null || response === void 0 ? void 0 : response.Message) === "Success") {
            localStorage.setItem("DASHBOARD_SESSION_ID", response.SessionNo);
            localStorage.setItem("DASHBOARD_SESSION_TIME", Date.now());
            return response.SessionNo;
        }
        else {
            console.log("SessionNo not generated");
        }
    }
    catch (err) {
        console.error("Error occurred while fetching Dion session number:", err);
    }
};
const EncryptSessionId = (str, key, iv) => {
    try {
        const salt = Math.random().toString(36).substring(2, 10);
        const saltedStr = salt + str;
        const text = CryptoJS.enc.Utf8.parse(saltedStr);
        const parsedKey = CryptoJS.enc.Base64.parse(key);
        const parsedIV = CryptoJS.enc.Base64.parse(iv);
        const encryptedText = CryptoJS.AES.encrypt(text, parsedKey, {
            keySize: 128 / 8,
            iv: parsedIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const b64 = encryptedText.toString();
        const e64 = CryptoJS.enc.Base64.parse(b64);
        const eHex = e64.toString(CryptoJS.enc.Hex).toUpperCase();
        return eHex;
    }
    catch (error) {
        console.error("Encryption failed:", error);
        return null;
    }
};
const encryptReportData = (key, iv, startDate, stockType, ISIN, generatedScrip, transactionType) => {
    try {
        let sessionNum = localStorage.getItem("DASHBOARD_SESSION_ID");
        //StartDate
        const date = new Date(startDate);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const formattedStartDate = `${year}-${month}-${day}`;
        const currentDate = new Date();
        const currentDateString = currentDate.toISOString().split('T')[0];
        const report = {
            LoginId: localStorage.getItem("ClientCode"),
            SessionNo: sessionNum,
            AccountId: stockType,
            StartDate: formattedStartDate,
            EndDate: currentDateString,
            SecurityCode: ISIN || "",
            Scrip: generatedScrip || "",
            ReportName: transactionType,
        };
        const encryptedData = EncryptSessionId(JSON.stringify(report), key, iv);
        return encryptedData;
    }
    catch (error) {
        console.error("Encryption failed:", error);
        throw error;
    }
};
const getReportData = async (token, sessionNo, key, iv, startDate, stockType, ISIN, generatedScrip, transactionType) => {
    try {
        const reportData = `{"data":"Report^DownloadReport^${encryptReportData(key, iv, startDate, stockType, ISIN, generatedScrip, transactionType)}"}`;
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("RequestRefNo", `${localStorage.getItem("ClientCode")}-${convertTimestamp(Date.now())}`);
        myHeaders.append("Content-Type", "application/json");
        const raw = reportData;
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        const response = await fetch(`${APP_BASE_PORTFOLIO_API_URL}PortfolioTrackerAPI/PTService.ProcessRequest`, requestOptions);
        // Parse the response JSON
        const responseData = await response.json();
        return responseData;
    }
    catch (error) {
        console.error("Error fetching report data:", error);
    }
};
export const getReport = async (startDate, stockType, ISIN, generatedScrip, transactionType) => {
    try {
        let AuthToken = localStorage.getItem("DASHBOARD_AUTH_TOKEN");
        let SessionID = localStorage.getItem("DASHBOARD_SESSION_ID");
        if (!AuthToken || !SessionID) {
            const authData = await getDashboardToken();
            AuthToken = authData.authToken;
            SessionID = authData.sessionId;
        }
        const KeyIV = hexToAscii(AuthToken);
        const key = KeyIV.split(",")[0];
        const iv = KeyIV.split(",")[1];
        // Now call the report API to fetch the report data
        const reportData = await getReportData(AuthToken, SessionID, key, iv, startDate, stockType, ISIN, generatedScrip, transactionType);
        return reportData;
    }
    catch (error) {
        console.error("Error during report fetching:", error);
    }
};
